export const calculatorHubCopy = {
  en: {
    eyebrow: "Command-ready calculators",
    title: "Plan fuel, ETA, distance, anchoring, wind feel, and boat speed with less guesswork.",
    intro: "Each calculator is designed for quick onboard planning, clear inputs, practical explanations, and conservative seamanship decisions before you leave the dock.",
    checklist: ["Use conservative numbers", "Check weather and tide", "Keep safety reserves"],
    calculator: "Calculator",
    disciplineEyebrow: "Planning discipline",
    disciplineTitle: "Calculators help most when they support cautious decisions.",
    disciplineText: "Use the numbers as a starting point, then compare them with local forecasts, tide, daylight, crew ability, boat condition, and official guidance.",
  },
  he: {
    eyebrow: "מחשבונים מוכנים לפיקוד",
    title: "תכננו דלק, זמן הגעה, מרחק, עגינה, תחושת רוח ומהירות סירה עם פחות ניחושים.",
    intro: "כל מחשבון נועד לתכנון מהיר על הסירה, קלט ברור, הסברים מעשיים והחלטות ימאות שמרניות לפני היציאה מהרציף.",
    checklist: ["השתמשו במספרים שמרניים", "בדקו מזג אוויר וגאות", "שמרו עתודות בטיחות"],
    calculator: "מחשבון",
    disciplineEyebrow: "משמעת תכנון",
    disciplineTitle: "מחשבונים מועילים ביותר כשהם תומכים בהחלטות זהירות.",
    disciplineText: "השתמשו במספרים כנקודת התחלה, ואז השוו לתחזיות מקומיות, גאות, אור יום, יכולת הצוות, מצב הסירה והנחיות רשמיות.",
  },
  es: {
    eyebrow: "Calculadoras listas para mando",
    title: "Planifica combustible, ETA, distancia, fondeo, viento sentido y velocidad del barco con menos conjeturas.",
    intro: "Cada calculadora está diseñada para planificación rápida a bordo, datos claros, explicaciones prácticas y decisiones marineras conservadoras antes de salir del muelle.",
    checklist: ["Usa números conservadores", "Comprueba tiempo y mareas", "Mantén reservas de seguridad"],
    calculator: "Calculadora",
    disciplineEyebrow: "Disciplina de planificación",
    disciplineTitle: "Las calculadoras ayudan más cuando apoyan decisiones prudentes.",
    disciplineText: "Usa los números como punto de partida y compáralos con pronósticos locales, marea, luz diurna, capacidad de la tripulación, estado del barco y guía oficial.",
  },
  it: {
    eyebrow: "Calcolatori pronti al comando",
    title: "Pianifica carburante, ETA, distanza, ancoraggio, vento percepito e velocità della barca con meno incertezze.",
    intro: "Ogni calcolatore è pensato per una rapida pianificazione a bordo, input chiari, spiegazioni pratiche e decisioni marinaresche conservative prima di lasciare il pontile.",
    checklist: ["Usa numeri conservativi", "Controlla meteo e maree", "Mantieni riserve di sicurezza"],
    calculator: "Calcolatore",
    disciplineEyebrow: "Disciplina di pianificazione",
    disciplineTitle: "I calcolatori aiutano di più quando supportano decisioni prudenti.",
    disciplineText: "Usa i numeri come punto di partenza, poi confrontali con previsioni locali, maree, luce diurna, capacità dell’equipaggio, stato della barca e indicazioni ufficiali.",
  },
  fr: {
    eyebrow: "Calculateurs prêts pour le bord",
    title: "Planifiez carburant, ETA, distance, mouillage, vent ressenti et vitesse du bateau avec moins d’incertitude.",
    intro: "Chaque calculateur est conçu pour une planification rapide à bord, des saisies claires, des explications pratiques et des décisions marines prudentes avant de quitter le quai.",
    checklist: ["Utilisez des valeurs prudentes", "Vérifiez météo et marée", "Gardez des marges de sécurité"],
    calculator: "Calculateur",
    disciplineEyebrow: "Discipline de planification",
    disciplineTitle: "Les calculateurs sont plus utiles lorsqu’ils soutiennent des décisions prudentes.",
    disciplineText: "Utilisez les chiffres comme point de départ, puis comparez-les aux prévisions locales, à la marée, à la lumière du jour, à l’équipage, à l’état du bateau et aux consignes officielles.",
  },
  de: {
    eyebrow: "Einsatzbereite Rechner",
    title: "Plane Kraftstoff, ETA, Distanz, Ankern, gefühlten Wind und Bootsgeschwindigkeit mit weniger Rätselraten.",
    intro: "Jeder Rechner ist für schnelle Bordplanung, klare Eingaben, praktische Erklärungen und konservative seemännische Entscheidungen vor dem Ablegen gedacht.",
    checklist: ["Konservative Werte nutzen", "Wetter und Tide prüfen", "Sicherheitsreserven behalten"],
    calculator: "Rechner",
    disciplineEyebrow: "Planungsdisziplin",
    disciplineTitle: "Rechner helfen am meisten, wenn sie vorsichtige Entscheidungen unterstützen.",
    disciplineText: "Nutze die Zahlen als Startpunkt und vergleiche sie mit lokalen Vorhersagen, Tide, Tageslicht, Crew-Fähigkeit, Bootszustand und offiziellen Hinweisen.",
  },
  pt: {
    eyebrow: "Calculadoras prontas para comando",
    title: "Planeie combustível, ETA, distância, ancoragem, vento sentido e velocidade do barco com menos incerteza.",
    intro: "Cada calculadora foi criada para planeamento rápido a bordo, entradas claras, explicações práticas e decisões náuticas conservadoras antes de sair do cais.",
    checklist: ["Use números conservadores", "Verifique meteorologia e maré", "Mantenha reservas de segurança"],
    calculator: "Calculadora",
    disciplineEyebrow: "Disciplina de planeamento",
    disciplineTitle: "As calculadoras ajudam mais quando apoiam decisões prudentes.",
    disciplineText: "Use os números como ponto de partida e compare com previsões locais, maré, luz do dia, capacidade da tripulação, estado do barco e orientação oficial.",
  },
  ar: {
    eyebrow: "حاسبات جاهزة للقيادة",
    title: "خطط للوقود ووقت الوصول والمسافة والرسو والرياح المحسوسة وسرعة القارب مع تخمين أقل.",
    intro: "صُممت كل حاسبة للتخطيط السريع على متن القارب، مع مدخلات واضحة وشروحات عملية وقرارات بحرية محافظة قبل مغادرة الرصيف.",
    checklist: ["استخدم أرقاماً محافظة", "تحقق من الطقس والمد والجزر", "احتفظ باحتياطيات السلامة"],
    calculator: "حاسبة",
    disciplineEyebrow: "انضباط التخطيط",
    disciplineTitle: "تكون الحاسبات أكثر فائدة عندما تدعم قرارات حذرة.",
    disciplineText: "استخدم الأرقام كنقطة بداية، ثم قارنها بالتوقعات المحلية والمد والجزر وضوء النهار وقدرة الطاقم وحالة القارب والإرشادات الرسمية.",
  },
  el: {
    eyebrow: "Υπολογιστές έτοιμοι για χρήση",
    title: "Σχεδιάστε καύσιμα, ETA, απόσταση, αγκυροβόληση, αίσθηση ανέμου και ταχύτητα σκάφους με λιγότερη αβεβαιότητα.",
    intro: "Κάθε υπολογιστής είναι σχεδιασμένος για γρήγορο σχεδιασμό στο σκάφος, καθαρές εισαγωγές, πρακτικές εξηγήσεις και συντηρητικές ναυτικές αποφάσεις πριν φύγετε από την προβλήτα.",
    checklist: ["Χρησιμοποιήστε συντηρητικούς αριθμούς", "Ελέγξτε καιρό και παλίρροια", "Κρατήστε αποθέματα ασφάλειας"],
    calculator: "Υπολογιστής",
    disciplineEyebrow: "Πειθαρχία σχεδιασμού",
    disciplineTitle: "Οι υπολογιστές βοηθούν περισσότερο όταν στηρίζουν προσεκτικές αποφάσεις.",
    disciplineText: "Χρησιμοποιήστε τους αριθμούς ως αφετηρία και συγκρίνετέ τους με τοπικές προγνώσεις, παλίρροια, φως ημέρας, ικανότητα πληρώματος, κατάσταση σκάφους και επίσημες οδηγίες.",
  },
  ru: {
    eyebrow: "Калькуляторы для решений на борту",
    title: "Планируйте топливо, ETA, расстояние, якорение, ощущаемый ветер и скорость лодки с меньшими догадками.",
    intro: "Каждый калькулятор создан для быстрого планирования на борту, понятных вводных, практических объяснений и осторожных морских решений перед выходом от причала.",
    checklist: ["Используйте консервативные значения", "Проверьте погоду и приливы", "Сохраняйте запас безопасности"],
    calculator: "Калькулятор",
    disciplineEyebrow: "Дисциплина планирования",
    disciplineTitle: "Калькуляторы полезнее всего, когда помогают принимать осторожные решения.",
    disciplineText: "Используйте цифры как отправную точку, затем сравните их с местным прогнозом, приливами, световым днем, опытом экипажа, состоянием лодки и официальными рекомендациями.",
  },
  tr: {
    eyebrow: "Kumandaya hazır hesaplayıcılar",
    title: "Yakıtı, ETA’yı, mesafeyi, demirlemeyi, hissedilen rüzgarı ve tekne hızını daha az tahminle planlayın.",
    intro: "Her hesaplayıcı, iskeleden ayrılmadan önce hızlı tekne üstü planlama, net girişler, pratik açıklamalar ve temkinli denizcilik kararları için tasarlandı.",
    checklist: ["Temkinli değerler kullanın", "Hava ve gelgiti kontrol edin", "Güvenlik payı bırakın"],
    calculator: "Hesaplayıcı",
    disciplineEyebrow: "Planlama disiplini",
    disciplineTitle: "Hesaplayıcılar, temkinli kararları desteklediğinde en çok işe yarar.",
    disciplineText: "Sayıları başlangıç noktası olarak kullanın; sonra yerel tahmin, gelgit, gün ışığı, mürettebat becerisi, tekne durumu ve resmi rehberlikle karşılaştırın.",
  },
  zh: {
    eyebrow: "指挥级计算器",
    title: "更少猜测地规划燃油、ETA、距离、锚泊、风感和船速。",
    intro: "每个计算器都用于快速船上规划，提供清晰输入、实用说明，并帮助你在离开码头前做出保守的航海决策。",
    checklist: ["使用保守数值", "检查天气和潮汐", "保留安全余量"],
    calculator: "计算器",
    disciplineEyebrow: "规划纪律",
    disciplineTitle: "当计算器支持谨慎决策时，它们最有帮助。",
    disciplineText: "将数字作为起点，然后与当地预报、潮汐、日照、船员能力、船况和官方指南进行比较。",
  },
};

export function getCalculatorHubCopy(lang = "en") {
  return calculatorHubCopy[lang] || null;
}